import loadable from '@/components/loadable';
import { APIType } from '@/constants';
export default {
    [APIType.BEACON_HEALTH]: loadable(() => import('../analytics/api-analytics/health-checks' /* webpackChunkName: "healthchecks" */)),
    generic: loadable(() => import('./generic-dashboard' /* webpackChunkName: "generic-dashboard" */)),
};
